import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-danger text-xs"
}

import { PropType } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FormErrors',
  props: {
  errors: {
    type: Array as PropType<{ $validator: string; $params: any }[]>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.errors?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, errIndex) => {
          return (_openBlock(), _createElementBlock("p", { key: errIndex }, _toDisplayString(_ctx.$t(`validations.${error.$validator}`, error.$params)), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})